import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AppLoading } from './AppLoading';
import { Toaster } from '@/components/ui/sonner';
import { ContactSupportButton } from './ContactSupportButton';

interface PositionWrapperProps {
	children?: ReactNode;
}

export const PositionWrapper = ({ children }: PositionWrapperProps) => {
	const { isInitializing } = useAuth();

	if (isInitializing) {
		return <AppLoading />;
	}

	return (
		<>
			{children || <Outlet />}
			<Toaster position="top-center" />
			<ContactSupportButton />
		</>
	);
};
